<template>
  <router-link
    v-if="href"
    :to="{ name:'pdf-viewer',params: {url: href } }"
  ><feather-icon
    icon="EyeIcon"
    class="cursor-pointer"
    size="16"
  /></router-link>
</template>

<script>

export default {
  name: 'FileDownloadComponent',
  props: {
    href: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
